import { Injectable } from "@angular/core";
import { SelectItem } from "primeng/api";
import { map, Observable, of } from "rxjs";
import { MICustomFunctionsParams } from "../../models/fields/custom-function-params";
import { FieldSchema, FormisForm, MCCodeListWrapperService, MCFieldAttributesService, MCFieldAutoCompleteService, MCFieldConfigurationService, MCFieldTypesService, Utils } from "@maslul/common-services";


@Injectable({
  providedIn: 'root'
})
export class FieldsOptionsService {


  constructor(
    private fieldTypes: MCFieldTypesService,
    private fieldConfiguration: MCFieldConfigurationService,
    private codeListService: MCCodeListWrapperService,
    private fieldCAutoCompleteService: MCFieldAutoCompleteService,
    private fieldAttributesService: MCFieldAttributesService,
  ) { }

  isNeedCreateOptionByValue(field: FieldSchema, formisForm: FormisForm) {
    return field.disableCondition == "true"
      && formisForm.model
      && Utils.findInObjByKey(formisForm.model, field.name)
      && (this.fieldTypes.isAutoComlete(field.type) || this.fieldTypes.isSelect(field.type))
      && this.fieldConfiguration.isHaveLabel(field, formisForm)
  }

  byModelValue(field: FieldSchema, formisForm: FormisForm) {
    const options = [Utils.findInObjByKey(formisForm.model, field.name)];
    return of(options);
  }

  byValues(field: FieldSchema, isTranslateValues: boolean | null = null) {
    let isTranslate = true;
    if (isTranslateValues !== null) {
      isTranslate = isTranslateValues;
    } else {
      const translate = field.attributes.find(att => att.key === 'translate')
      isTranslate = translate ? JSON.parse(translate.value) : true;
    }
    const options = this.codeListService.selectItemList(field.values, false, isTranslate)
    return options;
  }

  concatValues(options: Observable<SelectItem[]>, field: FieldSchema) {

    const isEQValue = (val1: any, val2: any) => {
      const numberCal1 = isNaN(parseInt(val1)) ? val1 : parseInt(val1);
      const numberCal2 = isNaN(parseInt(val2)) ? val2 : parseInt(val2);
      return numberCal1 === numberCal2;
    }

    options = options.pipe ?
      options.pipe(map(items => {
        const optionsValues: SelectItem[] = this.byValues(field, false)
        items = items.concat(optionsValues.filter(v => items.every(i => !isEQValue(i.value, v.value))));
        return items;
      })) : options
    return options;
  }

  addOtherValue(customFunctionsObj: MICustomFunctionsParams, items: any[]) {
    const isAddOtherValue = this.fieldAttributesService.getAttrValue(customFunctionsObj.fieldSchema.attributes, 'addOtherValue', false);

    if (isAddOtherValue) {
      items.push({ value: 99999, label: 'אחר' });
    }
    return items;
  }

  resetValueNotExistInList(items: any[], customFunctionsObj: MICustomFunctionsParams) {
    if (
      !this.fieldTypes.isAutoComlete(customFunctionsObj.fieldSchema.type) &&
      !this.fieldTypes.isSelect(customFunctionsObj.fieldSchema.type)
      || !(items && items.length)) {
      return;
    }
    // מחיקה של הערך הקיים בשדה אם כעת אינו קיים ברשימה
    const field = customFunctionsObj?.field?.formControl;
    const findField = items.find(i => i.value === field?.value?.value && i.label === field?.value?.label)
    if (!findField && field?.value) {
      customFunctionsObj.field.formControl?.setValue(null);
    }
  }

  isNeedGetLabel(field: FieldSchema, formisForm: FormisForm) {
    return formisForm.model && (
      this.fieldTypes.isAutoComlete(field.type) || this.fieldTypes.isSelect(field.type))
      && this.fieldConfiguration.isHaveValue(field, formisForm) && !this.fieldConfiguration.isHaveLabel(field, formisForm)
  }

  setLabel(options: SelectItem[], field: FieldSchema, formisForm: FormisForm) {
    const selectedModelItem = Utils.findInObjByKey(formisForm.model, field.name);

    const option = options?.find(s => s.value?.toString() === selectedModelItem.value?.toString())
    Utils.setInObjByKey(formisForm.model, field.name, option)

  }

  getOptions(customFunctionsObj: MICustomFunctionsParams): Observable<SelectItem[]> {
    let options: Observable<SelectItem[]>;
    const eventsCallBackService = customFunctionsObj.injector.get(customFunctionsObj.eventsCallBackService);

    const fieldSchema = customFunctionsObj.fieldSchema;
    const formisForm = customFunctionsObj.formisForm;

    if (this.isNeedCreateOptionByValue(fieldSchema, formisForm)) {
      options = this.byModelValue(fieldSchema, formisForm);
    }
    else {
      options = of([]);

      if (fieldSchema.serviceListCallback && eventsCallBackService.eventsCallBack[fieldSchema.serviceListCallback]) {
        customFunctionsObj.isOnSelect = true;
        options = eventsCallBackService.eventsCallBack[fieldSchema.serviceListCallback](customFunctionsObj);

        // if (this.isActiveOption(customFunctionsObj.tab)) {
        //   this.fieldsStoreService.increaseListsCounter(customFunctionsObj.tab, { rowId: customFunctionsObj.rowId });
        // }

        if (fieldSchema.values) {
          options = this.concatValues(options, fieldSchema)
        }

      }
      else {
        if (fieldSchema.listName) {
          options = this.codeListService.getList(fieldSchema.listName)
          // if (this.isActiveOption(customFunctionsObj.tab)) {
          //   this.fieldsStoreService.increaseListsCounter(customFunctionsObj.tab, { rowId: customFunctionsObj.rowId });//tab, { rowId: rowId })tab, { rowId: rowId })
          // }
        }
        else {
          if (fieldSchema.values) {
            options = of(this.byValues(fieldSchema))
          }

        }
      }
    }

    options = options.pipe ? options.pipe(map(items => {

      items = this.fieldCAutoCompleteService.sortBy(customFunctionsObj.fieldSchema.attributes, items);
      items = this.addOtherValue(customFunctionsObj, items);
      this.resetValueNotExistInList(items, customFunctionsObj);
      if (this.isNeedGetLabel(fieldSchema, formisForm)) {
        this.setLabel(items, fieldSchema, formisForm)
      }
      if (fieldSchema.serviceListCallback && eventsCallBackService.eventsCallBack[fieldSchema.serviceListCallback] || fieldSchema.listName) {
        // if (this.isActiveOption(customFunctionsObj.tab)) {
        //   this.fieldsStoreService.decreasListsCounter(customFunctionsObj.tab, { rowId: customFunctionsObj.rowId });//tab, { rowId: rowId })
        // }
      }
      return items;
    })) : options
    return options;
  }

}
